import slate from '@react-page/plugins-slate';
import customSlatePlugin from './customSlatePlugin';
import katexSlatePlugin from './katexSlatePlugin';
import typographyPlugin from './typographyPlugin';
export const defaultSlate = slate((def) => (Object.assign(Object.assign({}, def), { plugins: Object.assign(Object.assign({}, def.plugins), { 
        // you can also add custom plugins. The namespace `custom` is just for organizing plugins
        custom: {
            custom1: customSlatePlugin,
            katex: katexSlatePlugin,
        } }) })));
// you can further customize slate to your needs
export const migeranWebSlate = slate((def) => (Object.assign(Object.assign({}, def), { name: def.id, plugins: {
        // here we do not use all plugins, but select them
        headings: typographyPlugin.headings,
        link: def.plugins.link,
        lists: def.plugins.lists,
        quotes: def.plugins.quotes,
        code: def.plugins.code,
        emphasize: def.plugins.emphasize,
        alignment: def.plugins.alignment,
        paragraphs: {
            paragraph: typographyPlugin.paragraph,
            pre: def.plugins.paragraphs.pre,
        },
    } })));
//# sourceMappingURL=slate.js.map